import { PAGE_NUMBER, SrmBoolean } from "helpers/helper";
export const types = {
  SET_STATE: "SET_STATE",
  ADD_PRODUCT: "ADD_PRODUCT",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  GET_PRICE: "GET_PRICE",
  EDIT_QUANTITY: "EDIT_QUANTITY",
  REMOVE_PRODUCT: "REMOVE_PRODUCT",
  EDIT_RATE: "EDIT_RATE",
  EDIT_PRICE: "EDIT_PRICE",
  SET_RATES: "SET_RATES",
  RESET_SEARCH: "RESET_SEARCH",
  EDIT_METER_CHARGE: "EDIT_METER_CHARGE",
  EDIT_UNIT_TOTAL: "EDIT_UNIT_TOTAL"
};

export default function (state, action) {
  const { payload } = action || {};

  switch (action.type) {
    case types.SET_STATE:
      return { ...state, ...payload };
    case types.RESET_SEARCH:
      return { ...state, page: PAGE_NUMBER.ONE, query: "" };
    case types.ADD_PRODUCT: {
      const product = { ...payload };
      const productsToSubmit = [...state.productsToSubmit];

      // fix key conflict between APIs
      product.availabilityQuantity = product.quantity;
      product.quantity = payload.quantity || 1;
      product.mode = "A";
      product.index = productsToSubmit.length;
      productsToSubmit.push(product);
      return { ...state, productsToSubmit };
    }
    case types.UPDATE_PRODUCT: {
      const { index } = payload;
      let productsToSubmit = [...state.productsToSubmit];

      const productIndex = productsToSubmit.findIndex(p => p.index === index);
      productsToSubmit[productIndex] = { ...payload }

      return { ...state, productsToSubmit };
    }
    case types.REMOVE_PRODUCT: {
      const { product, index } = payload;
      const productsToSubmit = [...state.productsToSubmit];
      const productIndex = productsToSubmit.findIndex(
        p => index !== undefined ? p.index === index : p.product === product
      );
      if (productIndex !== -1) {
        productsToSubmit.splice(productIndex, 1);
      }
      return {
        ...state,
        productsToSubmit: productsToSubmit.map((product, index) => ({ ...product, index }))
      };
    }
    case types.SET_RATES: {
      const { product: productNumber, index, rates, rate } = payload;
      const productsToSubmit = [...state.productsToSubmit];

      const product = productsToSubmit.find(p => index !== undefined ? p.index === index : p.product === productNumber);

      product.rates = rates;
      product.rate = rate;

      return {
        ...state,
        productsToSubmit
      };
    }
    case types.GET_PRICE: {
      const productsToSubmit = state.productsToSubmit.map(({ ...product }) => {
        if (product.index === payload.productIndex) {
          product.rate = payload.rate;
        }
        return product;
      });
      return { ...state, productsToSubmit };
    }
    case types.EDIT_RATE: {
      const { productIndex, rate } = payload;

      const productsToSubmit = [...state.productsToSubmit];
      const product = productsToSubmit.find(p => p.index === productIndex);

      if (product.type === "R") {
        product.rate = rate;
      } else {
        product.overrideListPrice = true;
        product.listPrice = rate;
      }

      return { ...state, productsToSubmit };
    }
    case types.EDIT_PRICE: {
      const { productNumber, listPrice, index } = payload;

      const productsToSubmit = [...state.productsToSubmit];
      const product = productsToSubmit.find(p => index !== undefined ? p.index === index : p.product === productNumber);

      product.overrideListPrice = true;
      product.listPrice = listPrice;

      return { ...state, productsToSubmit };
    }
    case types.EDIT_UNIT_TOTAL: {
      const { productNumber, unitTotal, index } = payload;

      const productsToSubmit = [...state.productsToSubmit];
      const product = productsToSubmit.find(p => index !== undefined ? p.index === index : p.product === productNumber);

      product.overrideListPrice = true;
      product.unitTotal = unitTotal;

      return { ...state, productsToSubmit };
    }
    case types.EDIT_QUANTITY: {
      const { product: productNumber, index, quantity } = payload;

      let productsToSubmit = [...state.productsToSubmit];
      const product = productsToSubmit.find(p => index !== undefined ? p.index === index : p.product === productNumber);

      product.quantity = quantity;
      return { ...state, productsToSubmit };
    }
    case types.EDIT_METER_CHARGE:
      const { productNumber, meterCharge, index } = payload;

      const productsToSubmit = [...state.productsToSubmit];
      const product = productsToSubmit.find(p => index !== undefined ? p.index === index : p.product === productNumber);

      product.meterCharge = meterCharge;

      return { ...state, productsToSubmit };
    default:
      throw new Error("invalid action");
  }
}
